import { TransactionSubtypeEnum } from "@/model/data/enums/TransactionSubtypeEnum";
import { TransactionTypeEnum } from "@/model/data/enums/TransactionTypeEnum";
import { IFilterInstallations } from "../supportObjects/IFilterInstallations";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";
import { TransactionsFilterData } from "./TransactionsFilterData";

export class GetTransactionListReqData implements IFilterInstallations, IPaginationFilter {
    offset: number;
    queryLimit: number;
    orderBy: string[];
    orderByDescending: boolean[];
    installationNames: string[] = null;
    folderIds: number[] = null;
    branchNames: string[] = null;

    startDate: Date;
    endDate: Date;
    transTypes: TransactionTypeEnum[] = null;
    dateFilterType: number;
    userId: string;
    userOrganization: string;
    userInfo: string;
    shiftNumber: string;
    channelId: string;
    serialNumber: string;
    startingTransactionId: number = null;
    endingTransactionId: number = null;
    envelopeId: string = null;
    transactionSubTypes: TransactionSubtypeEnum[] = null;
    bagId: string = null;

    checkTotalTransactionsCount: boolean = true;
    loadIntegrationFeedback: boolean = true;

    fillFromTransactionsFilterData(data: TransactionsFilterData) {
        this.startDate = new Date(
            Date.UTC(
                data.startDate.getFullYear(),
                data.startDate.getMonth(),
                data.startDate.getDate(),
                data.startDate.getHours(),
                data.startDate.getMinutes(),
                data.startDate.getSeconds()
            )
        );
        this.endDate = new Date(
            Date.UTC(data.endDate.getFullYear(), data.endDate.getMonth(), data.endDate.getDate(), data.endDate.getHours(), data.endDate.getMinutes(), data.endDate.getSeconds())
        );
        if (data.transTypes && data.transTypes.length) {
            let transSubtypes = data.transTypes.filter((l) => l >= 1000);
            if (transSubtypes) this.transactionSubTypes = transSubtypes.map((t) => t - 1000);
            this.transTypes = data.transTypes.filter((l) => l < 1000);
        }
        if (data.dateFilterType && [0, 1].includes(data.dateFilterType)) this.dateFilterType = data.dateFilterType;

        this.loadIntegrationFeedback = data.loadIntegrationFeedback;

        if (data.userId && data.userId.length) this.userId = data.userId;
        if (data.userOrganization && data.userOrganization.length) this.userOrganization = data.userOrganization;
        if (data.userInfo && data.userInfo.length) this.userInfo = data.userInfo;
        if (data.shiftNumber && data.shiftNumber.length) this.shiftNumber = data.shiftNumber;
        if (data.channelId && data.channelId.length) this.channelId = data.channelId;
        if (data.serialNumber && data.serialNumber.length) this.serialNumber = data.serialNumber;
        if (data.startingTransactionId && /^\d+$/.test(data.startingTransactionId)) this.startingTransactionId = Number.parseInt(data.startingTransactionId);
        if (data.endingTransactionId && /^\d+$/.test(data.endingTransactionId)) this.endingTransactionId = Number.parseInt(data.endingTransactionId);
        if (data.envelopeId && data.envelopeId.length) this.envelopeId = data.envelopeId;
        if (data.bagId && data.bagId.length) this.bagId = data.bagId;
    }
}
